export default __webpack_public_path__ + "static/media/interview-icon.9d005036.png";